import React, {ReactElement} from "react";
import Tribe from "../../enum/Tribe";
import {useTranslationContext} from "../../../react/providers/TranslationContext";
import OffComparison from "./OffComparison";

export default function TribeComparison(props: object): ReactElement {
    const {getTranslator} = useTranslationContext();
    const translate = getTranslator('react/component/Travian/TribeComparison');

    return <div>
        <OffComparison />
    </div>
}
